import { memo, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Space } from 'antd';
import _ from 'lodash';
import { dateToString } from '@/utils';
import { useGetParentGeneralInquiriesQuery } from '@/services/parent-api';
import { PlusSvg } from '@/assets/icons';
import Table from '@/components/table';
import Button from '@/components/button';
import AddModal from './add-modal';
import CompleteModal from './complete-modal';
import LettersModal from './letters-modal';

const GeneralInquiries = ({ parentId, permissions }) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching, refetch } = useGetParentGeneralInquiriesQuery({ parentId, pageNumber });
  const items = useMemo(
    () => data?.data.map((item) => ({ ..._.omit(item, ['children']), children_data: item.children })),
    [data],
  );

  const [isAddModalOpen, openAddModal] = useState(false);
  const [selectedId1, setSelectedId1] = useState();
  const [selectedId2, setSelectedId2] = useState();

  const columns = [
    {
      title: 'Inquiry Date',
      dataIndex: 'date',
      render: (value) => dateToString(value),
    },
    {
      title: 'Letter Name',
      dataIndex: 'letterName',
    },
    {
      title: 'Letters',
      dataIndex: 'letters',
      render: (value) => value.length,
    },
    {
      title: 'Status',
      key: 'status',
      render: (_, record) =>
        [
          record.inquiryStatus.name,
          record.completedOn && `on ${dateToString(record.completedOn)}`,
          record.completedReason.name,
        ]
          .filter((s) => s)
          .join(' '),
    },
    {
      title: permissions.events && (
        <Button type="primary" icon={<PlusSvg fontSize="12" />} onClick={() => openAddModal(true)}>
          Add
        </Button>
      ),
      key: 'action',
      align: 'right',
      render: (_, record) => (
        <Space size="small">
          {permissions.writeParent && record.isOpen && (
            <Button type="link" onClick={() => setSelectedId1(record.inquiryId)}>
              Completed
            </Button>
          )}
          <Button type="link" onClick={() => setSelectedId2(record.inquiryId)}>
            Letters
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={items}
        rowKey="inquiryId"
        loading={isFetching}
        pageInfo={data}
        size="small"
      />

      <AddModal parentId={parentId} open={isAddModalOpen} refetch={refetch} onClose={() => openAddModal(false)} />
      <CompleteModal parentId={parentId} inquiryId={selectedId1} refetch={refetch} onClose={() => setSelectedId1()} />
      <LettersModal parentId={parentId} inquiryId={selectedId2} onClose={() => setSelectedId2()} />
    </>
  );
};

export default memo(GeneralInquiries);
